import { map, size, split } from "lodash";
import { RequestDataTransformerProps } from "@/pages/requests/types";
import { SubmitRequestsPayloadPart } from "@/services/api";
import { format } from "date-fns";
import { CONTRACTORS_LICENCE_DATE_FORMAT } from "@/constants";

export const requestDataTransformer = ({
  activeApplication,
  user,
  requestFormData,
  IsAccuracyOfInfoChecked,
  referenceNumber,
  IsDraft,
  requestDetails,
}: RequestDataTransformerProps): SubmitRequestsPayloadPart => {
  /* eslint-disable-next-line */
  console.log(requestDetails);

  const { TradeLicenseDocument, Id, ...rest } =
    requestFormData?.SubContractor || {};

  const docTypeId = TradeLicenseDocument?.DocTypeId;

  const base64 =
    docTypeId && requestFormData?.RequestDocuments
      ? requestFormData?.RequestDocuments[docTypeId]?.base64
      : null;

  const FileBase64 = docTypeId
    ? size(split(base64 as string, "base64,")[1])
      ? split(base64 as string, "base64,")[1]
      : base64
    : base64;

  const SubContractor = {
    ...rest,
    Id,
    MobileNumber: user?.Contractor?.MobileNumber,
    ContractorCicpaId: user?.Contractor?.ContractorCicpaId,
    AdditionalEmail: user?.Contractor?.AdditionalEmail,
    TradeLicenseDocument: {
      ...TradeLicenseDocument,
      ContractorId: user?.Contractor?.ContractorId,
      FileName: TradeLicenseDocument?.DocNameEn,
      FileBase64: FileBase64,
    },
  };

  const _startDate = requestFormData?.From;
  // || requestDetails?.Lookups?.LOARequestBasicDetails?.StartDate;

  const ActivityStartDate = _startDate
    ? format(_startDate as Date, CONTRACTORS_LICENCE_DATE_FORMAT)
    : undefined;

  const _endDate = requestFormData?.To;
  // || requestDetails?.Lookups?.LOARequestBasicDetails?.EndDate;

  const ActivityEndDate = _endDate
    ? format(_endDate as Date, CONTRACTORS_LICENCE_DATE_FORMAT)
    : undefined;

  const payload: SubmitRequestsPayloadPart = {
    LoaRequset: {
      RequestInfo: {
        Application:
          // requestDetails?.Lookups.ApplicationLookup .Applications?.[0] ||
          {
            Id: activeApplication?.Id,
            ApplicationNameAr: activeApplication?.ApplicationNameAr,
            ApplicationNameEn: activeApplication?.ApplicationNameEn,
            ApplicationDomainId: activeApplication?.ApplicationDomainId,
            ActionType: activeApplication?.ActionType,
            Company: requestFormData?.Companies,
            RequiredDocuments: map(requestFormData?.RequestDocuments, doc => {
              const { name, base64, ...rest } = doc;

              const _FileBase64 = base64
                ? size(split(base64 as string, "base64,")[1])
                  ? split(base64 as string, "base64,")[1]
                  : base64
                : base64;

              return {
                ...rest,
                FileName: name,
                FileBase64: _FileBase64,
              };
            }),
          },
        ActionType:
          // requestDetails?.Lookups.ApplicationLookup.Applications?.[0].ActionType ||
          activeApplication?.ActionType,
        ReferenceNo: referenceNumber,
        InitiatorCompanyNo:
          // requestDetails?.Lookups?.LoaContractsLookup?.LoaContracts?.[0].Employee?.CompanyId ||
          requestFormData?.ContractType?.Employee?.CompanyId,
        initiatorEmpNo:
          // requestDetails?.Lookups?.LoaContractsLookup?.LoaContracts?.[0].Employee?.EmpNo ||
          requestFormData?.ContractType?.Employee?.EmpNo,
        // InitiatorEmail: "string",
        // Remarks: "string",
        // QFormRequestId: 0,
        IsAccuracyOfInfoChecked,
        IsDraft,
      },
      LoaInfo: {
        ActivityNameAr:
          // requestDetails?.Lookups?.ServicePurposeLookup?.ServicePurposes?.[0]
          //   ?.PurposeAr ||
          requestFormData?.Purpose?.PurposeAr || "",
        ActivityNameEn:
          // requestDetails?.Lookups?.ServicePurposeLookup?.ServicePurposes?.[0]
          //   ?.PurposeEn ||
          requestFormData?.Purpose?.PurposeEn || "",
        // AggrementNo: "string",
        // ContractTitle: "string",
        ActivityStartDate,
        ActivityEndDate,
        NoOfPersons:
          Number(requestFormData?.NumberOfPersonnel) || // || Number(requestDetails?.LOARequestBasicDetails?.Number_Of_Persons)
          0,
        NoOfVehicles:
          Number(requestFormData?.NumberOfVehicles) || // || Number(requestDetails?.LOARequestBasicDetails?.NoOfVehicles)
          0,
        NoOfCameras:
          Number(requestFormData?.NumberOfCameras) || // || Number(requestDetails?.LOARequestBasicDetails?.NumberOfCameras)
          0,
        NoOfVessels:
          Number(requestFormData?.NumberOfVessels) || // || Number(requestDetails?.LOARequestBasicDetails?.NumberOfVessels)
          0,
        HasPersons: Boolean(requestFormData?.NumberOfPersonnel),
        // SpcRemarks: "string",
        // VesselsName: "string",
        ContractNo: requestFormData?.ContractType?.ContractNo,
        // || requestDetails?.Lookups?.LoaContractsLookup?.LoaContracts?.[0]?.ContractNo,
        ContractType: requestFormData?.ContractType?.ContractTypeId,
        // || requestDetails?.Lookups?.LoaContractsLookup?.LoaContracts?.[0]?.Id,
        Contractor: user?.Contractor,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        SubContractor,
      },
      Areas: requestFormData?.Areas, // || requestDetails?.Lookups?.AreaLookup?.Areas,
      LoaWorkers:
        // requestDetails?.LoaWorkers?.LoaWorkers ||
        map(requestFormData?.Personnels, worker => {
          return {
            ...worker,
            isDraft: IsDraft,
          };
        }),
    },
  };

  if (!TradeLicenseDocument || Id === 0) {
    delete payload.LoaRequset.LoaInfo.SubContractor;
  }

  return payload;
};
